(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnification-filter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const container = document.querySelector('.magnification-toggles');
    if (!container) return;

    const filterKey = container.dataset.filterKey;
    const collectionUrl = container.dataset.collectionUrl;

    function getFacetForm() {
      return document.querySelector('facet-filters-form');
    }

    function getFormElement() {
      return document.querySelector('facet-filters-form form');
    }

    function applyMagFilter(value) {
      const form = getFormElement();
      if (!form) return;
      const formData = new FormData(form);
      formData.set(filterKey, value);
      const facetForm = getFacetForm();
      if (facetForm && typeof facetForm.manualApplyFilter === 'function') {
        facetForm.manualApplyFilter(formData);
      }
    }

    function resetMagFilter() {
      const form = getFormElement();
      if (!form) return;
      const formData = new FormData(form);
      formData.delete(filterKey);
      const facetForm = getFacetForm();
      if (facetForm && typeof facetForm.manualApplyFilter === 'function') {
        facetForm.manualApplyFilter(formData);
      }
    }

    container.querySelectorAll('.toggles a').forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        if (toggle.classList.contains('active')) {
          resetMagFilter();
        } else {
          applyMagFilter(toggle.getAttribute('data-value'));
        }
      });
    });

    const resetButton = container.querySelector('.toggle-header a.clear-filter');
    if (resetButton) {
      resetButton.addEventListener('click', function (event) {
        event.preventDefault();
        resetMagFilter();
      });
    }

    function handleActiveToggle() {
      setTimeout(function () {
        const form = getFormElement();
        if (!form) return;

        const filterParams = new FormData(form);
        const activeFilter = filterParams.get(filterKey);
        const clearBtn = container.querySelector('.toggle-header a.clear-filter');

        const previousActive = container.querySelector('.toggles > a.active');
        if (previousActive) {
          previousActive.classList.remove('active');
          previousActive.setAttribute('href', previousActive.getAttribute('data-prev-href'));
        }

        if (activeFilter) {
          const activeToggle = container.querySelector(
            '.toggles > a[data-value="' + activeFilter + '"]'
          );
          if (activeToggle) {
            activeToggle.classList.add('active');
            activeToggle.setAttribute('href', collectionUrl);
          }
          if (clearBtn) clearBtn.classList.add('active');
        } else if (clearBtn) {
          clearBtn.classList.remove('active');
        }
      }, 200);
    }

    window.addEventListener('collection::render', handleActiveToggle);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
